import {SignalDefinitionSchema} from '../../signalDefinition';
import {ApiDefinition} from '../definitions';
import {z} from 'zod';

export const MaxSignalDefinitions = 30;

const creationFields = {
  id: true,
  timestamp: true,
} as const;
export const PostSignalDefinition = {
  path: 'signalDefinition/createSignalDefinition',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: SignalDefinitionSchema.omit(creationFields),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const DeleteSignalDefinition = {
  path: 'signalDefinition/deleteSignalDefinition',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    signalId: z.string(),
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;
